import { getCurrencyForRegion } from "../models/country";
const driverTransKeyMap = {
    Items: "items",
    Visits: "visits",
    Customers: "customers",
    CubicMeters: "cubicMeters",
    Currency: "currency",
    Picks: "picks",
};
export const getDriverTransKey = (driver, t, countryCode) => {
    const key = driverTransKeyMap[driver] ?? driver;
    if (driver === "Currency") {
        const currencyCode = getCurrencyFromCountry(countryCode);
        const currencySymbol = currencyCode !== null ? getCurrencySymbol(currencyCode, countryCode) : "";
        return currencySymbol;
    }
    return t(`labels.${key}`, { defaultValue: driver });
};
const getCurrencySymbol = (currencyCode, locale) => {
    try {
        const formatter = new Intl.NumberFormat(locale, {
            style: "currency",
            currency: currencyCode,
            currencyDisplay: "symbol",
        });
        const parts = formatter.formatToParts(0);
        const symbolPart = parts.find((part) => part.type === "currency");
        return symbolPart?.value ?? currencyCode;
    }
    catch (error) {
        console.error("Error getting currency symbol:", error);
        return currencyCode;
    }
};
const getCurrencyFromCountry = (countryCode) => {
    try {
        const regionMatch = countryCode.match(/^[A-Z]{2}$/i);
        if (regionMatch) {
            const region = regionMatch[0]?.toUpperCase() ?? "";
            return getCurrencyForRegion(region);
        }
        return null;
    }
    catch (error) {
        console.error("Error getting currency from locale:", error);
        return "EUR";
    }
};
//# sourceMappingURL=driverTransforms.js.map